import { render } from "./FilterBlock.vue?vue&type=template&id=57fcd0a5"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"

import "./FilterBlock.vue?vue&type=style&index=0&id=57fcd0a5&lang=scss"
script.render = render

export default script